<template>
  <div id="url_valid">
    <!--div id="border">
      <b-modal :active.sync="isEditable" :width="640" scroll="keep" :on-cancel="closeModal">
        <div class="modal-card" style="auto">
          <section class="modal-card-body"> 
            <img :src="popImage" class="img-responsive"/>
          </section>
        </div>
       </b-modal>
    </div-->
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      isEditable: false,
      popImage: "https://www.doodhvale.com/hmi_images/popup-img.png",
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      const params = new URLSearchParams();
      var fullUrl = document.URL;
      var splitUrl = fullUrl.split("appLink?");
      if (splitUrl[1] != null) {
        params.append("source_name", splitUrl[1]);
        axios({
          url: process.env.BASE_API + "/accounts/app-download-source-name",
          method: "post",
          data: params,
          withCredentials: false,
          headers: {},
        });
      }
      if (navigator.userAgent.indexOf("Android") !== -1) {
        location.replace(
          "https://play.google.com/store/apps/details?id=com.technologies.subtlelabs.doodhvale&hl=en"
        );
      } else if (navigator.userAgent.indexOf("like Mac") !== -1) {
        location.replace(
          "https://apps.apple.com/in/app/doodhvale/id1435706071"
        );
      } else {
        location.replace("https://www.doodhvalefarms.com");
      }
    },
    closeModal() {
      this.isEditable = false;
      this.fetchData();
    },
  },
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/AppLink.vue